import find from 'lodash/find';
import filter from 'lodash/filter';
import last from  'lodash/last';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import qs from 'qs';
import geoLandingLangRelations from '../../../shared/js/geo_landing_lang_relations';

export const getPagesByType = (data, type ) => {
	return Object.keys(data)
		.filter(key => key.indexOf(type) !== -1)
		.map(key => data[key] == true ? {id: parseInt(last( key.split('_') ))} : false)
		.filter(item => !!item && !!item.id);
};

export const getSnippetsByType = (data, type ) => {
	return Object.keys(data)
		.filter(key => key.indexOf(type) !== -1)
		.map(key => data[key] ? {id: parseInt(last( key.split('_') )), text: data[key]} : false)
		.filter(item => !!item);
};

export const getPagesFromItemField = (pagesList, baseList, type) => {
	const pagesForType = filter(baseList,
		p => p.type == type && !!find(pagesList, pl => p.id == pl.id )
	);
	const lost = filter(pagesList, p => {
		return p.type == type && !find(pagesForType, pt => pt.id == p.id);
	});

	const result = {};
	pagesForType && pagesForType.forEach(page => {
		result[[`${type}_pages_id_${page.id}`]] = true;
		result[[`${type}_pages`]] = page.id;
	});
	lost && lost.forEach(page => {
		result[[`${type}_pages_id_${page.id}`]] = true;
		result[[`${type}_pages`]] = page.id;
	});

	return result;
};

export const getLandingSnippetsFields = snippets => {
	const result = {};
	if (snippets) {
		Object.keys(snippets).forEach(snippetName => {
			const snippetObject = snippets[snippetName];
			forEach(snippetObject, s => {
				result[[`${snippetName}_snippet_${s.id}`]] = s.text;
			});
		});
	}
	return result;
};

export const makeStatisticQuery = (queryObject = {}) => {
	let query = { groups:['date'] };
	return qs.stringify({
		...query,
		...queryObject
	});
};

export const checkIsFromChain = (chain, landings, transits) => {
	if (isEmpty(chain)) return false;
	if (landings.length === 1 && transits.length === 1) {
		return get(landings, ['0', 'id']) === chain.landing_id
			&& get(transits, ['0', 'id']) === chain.transit_id;
	}
	return false;
};

export const getPossibleLandingLocations = (lang, targetingLocations, campaignCountryCode) => {

	if (campaignCountryCode) {
		switch (typeof campaignCountryCode) {
			case 'string': return [{value: campaignCountryCode}];
			case 'object': return [campaignCountryCode];
		}
	}

	if (!targetingLocations || !targetingLocations.length) {
		return [];
	}
	const locationsByLang = Object.keys(geoLandingLangRelations)
		.filter(geo => !!geoLandingLangRelations[geo].includes(lang));

	return targetingLocations
		.filter(location => locationsByLang.includes(location.country_code))
		.map(location => ({label: location.country_name, value: location.country_code}));
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/functions.js